import appConfig from "config/appConfig";

export const getGoogleMapsUrl = (lat: number, lng: number) =>
	`${appConfig.GLOBAL_CONSTANTS.GOOGLE_MAPS_URL}${lat},${lng}`;
